module.exports = __webpack_public_path__ + "img/img_family_01.251abbd4.svg";